var map = {
	"./aquario.json": "lNKB",
	"./aries.json": "KaDf",
	"./cancer.json": "UXa1",
	"./capricornio.json": "IZA1",
	"./escorpiao.json": "W4Fu",
	"./gemeos.json": "z8jd",
	"./leao.json": "J0DP",
	"./libra.json": "d/Lb",
	"./peixes.json": "voyl",
	"./sagitario.json": "cqOi",
	"./touro.json": "dm9x",
	"./virgem.json": "dkBj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r3zS";